import { Collection } from 'modules/core/lib/mobx-rest'

import { AccessGroup } from 'modules/automations/store/models/AccessGroup'

class AccessGroupsCollection extends Collection<AccessGroup> {
  get cacheKey(): string {
    return 'accessGroups'
  }

  model() {
    return AccessGroup
  }
}

export const accessGroups = new AccessGroupsCollection()
